import { render, staticRenderFns } from "./update-password.vue?vue&type=template&id=1d65b269&scoped=true"
import script from "./update-password.vue?vue&type=script&lang=js"
export * from "./update-password.vue?vue&type=script&lang=js"
import style0 from "./update-password.vue?vue&type=style&index=0&id=1d65b269&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d65b269",
  null
  
)

export default component.exports